import { Env } from './env.model';

export const environment: Env = {
  stage: 'prod',
  s3PicsBucket: 'prod',
  apiUrl: 'https://api.personalidate.com',
  googleAutocompleteApiKey: 'AIzaSyBktHBN6icKFHvmJkBVe4ntnkb3Ki578pE',
  vapidPublicKey:
    'BAUmP7Q_nYuW4_z28ZGELtxiM-nwMizON7pOTGcLx7TQ1eN00pvE0S7dNvXChr9PhDAKz2bVQF2LHWNVYgToN30',
  facebookLoginAppId: '983693590204501',
  googleLoginClientId:
    '1000513449866-3k0e7f36f4l2he4aggq6l54rukt4og6v.apps.googleusercontent.com',
};
